<template>
  <div>
    <app-heading :text="'Audit Logs'" :heading="'main'"></app-heading>

    <v-divider class="mt-6 mb-4"></v-divider>

    <ag-grid-vue
      class="ag-theme-alpine"
      style="height: 60vh"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="filteredItems"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :frameworkComponents="frameworkComponents"
      rowSelection="single"
    ></ag-grid-vue>
    <!-- @cellClicked="onRowClicked" -->
    <v-dialog v-model="viewAuditLogDialog" width="700" persistent>
      <v-card class="pb-4">
        <v-card-title class="primary">
          <span class="white--text">Log Details</span>
        </v-card-title>
        <v-card-text class="pt-4 black--text">
          <v-row>
            <v-col cols="6">
              <div class="subtitle-1 font-weight-bold">NBN Order ID</div>
              <div>{{ selectedLog.nbnOrderID }}</div>
            </v-col>
            <v-col cols="6">
              <div class="subtitle-1 font-weight-bold">AVC ID</div>
              <div>{{ selectedLog.avcId }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <div class="subtitle-1 font-weight-bold">User Email</div>
              <div>{{ selectedLog.userEmail }}</div>
            </v-col>
            <v-col cols="6">
              <div class="subtitle-1 font-weight-bold">Request Type</div>
              <div>{{ selectedLog.requestType }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12 black--text">
              <div class="subtitle-1 font-weight-bold">Request Payload</div>
              <v-card
                outlined
                class="pa-2"
                v-if="!isUpdateStyleAudit(selectedLog.requestType)"
              >
                {{ selectedLog.requestPayload }}
              </v-card>
              <v-card outlined class="pa-2" v-else>
                <v-card-text v-if="selectedAuditChanges.length">
                  <p v-if="selectedAuditReason">
                    <b>Reason:</b> {{ selectedAuditReason }}
                  </p>
                  <v-simple-table dense>
                    <thead>
                      <tr>
                        <th>Field</th>
                        <th>Old Value</th>
                        <th>New Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="change in selectedAuditChanges" :key="change.field">
                        <td>{{ change.field }}</td>
                        <td>{{ change.oldValue }}</td>
                        <td>{{ change.newValue }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
                <v-card-text
                  v-else-if="
                    selectedLog.requestPayload &&
                      selectedLog.requestPayload.includes('oldValues') &&
                      selectedLog.requestPayload.includes('newValues')
                  "
                >
                  <p>
                    <b>Old Values:</b>
                    {{ JSON.parse(selectedLog.requestPayload).oldValues }}
                  </p>
                  <p class="mb-0">
                    <b>New Values: </b>
                    {{ JSON.parse(selectedLog.requestPayload).newValues }}
                  </p>
                </v-card-text>
                <v-card-text v-else
                  >{{ selectedLog.requestPayload }}
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="subtitle-1 font-weight-bold">Response</div>
              <div>{{ selectedLog.response }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <div class="subtitle-1 font-weight-bold">Date Created</div>
              <div>{{ _formatDateTime(selectedLog.dateTime) }}</div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mt-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="viewAuditLogDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import { formatDateTime } from "@/plugins/global-functions";
import TableActions from "@/components/common/nbn-table-actions";
import {
  isCorrectionAuditRequest,
  isHiddenAuditHistoryField,
  parseAuditPayload
} from "@/utils/nbn-order-correction";

export default {
  name: "QuoteManagement",
  components: { AgGridVue },
  data: () => ({
    showAddQuote: false,
    showEditQuote: false,
    filterCompleted: false,
    filterCancelled: false,
    filterRejected: false,
    isEditing: false,
    quoteData: {},
    statusFilter: -1,
    pageSize: 50,
    keyword: null,
    items: [],
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true
    },
    gridOptions: {},
    columnDefs: [],
    frameworkComponents: null,
    viewAuditLogDialog: false,
    selectedLog: {}
  }),
  computed: {
    filteredItems: function() {
      let vm = this;
      return vm.items;
    },
    selectedAuditPayload() {
      return parseAuditPayload(this.selectedLog && this.selectedLog.requestPayload);
    },
    selectedAuditReason() {
      return this.selectedAuditPayload ? this.selectedAuditPayload.reason : "";
    },
    selectedAuditChanges() {
      const parsed = this.selectedAuditPayload;
      if (!parsed || !parsed.newValues) {
        return [];
      }

      return Object.keys(parsed.newValues)
        .filter(field => !isHiddenAuditHistoryField(field))
        .map(field => ({
          field,
          oldValue: parsed.oldValues ? parsed.oldValues[field] : "",
          newValue: parsed.newValues[field]
        }));
    }
  },
  methods: {
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
    },
    // onRowClicked(args) {
    //   let vm = this;
    //   var payload = { quoteID: args.data.quoteId };
    //   vm.getQuoteAsync(payload)
    //     .then(data => {
    //       vm.$refs.editQuote.showEditQuote = true;
    //       vm.showEditQuote = true;
    //       vm.quoteData = { response: data, quoteData: args.data };
    //     })
    //     .catch(() => {});
    // },
    getAuditLogs() {
      let vm = this;

      vm.retrieveAuditLogs()
        .then(data => {
          vm.items = data.data;
          vm.gridApi.sizeColumnsToFit();
        })
        .catch(() => {});
    },
    formatJSON(jsonString) {
      try {
        const parsed = JSON.parse(jsonString);
        return JSON.stringify(parsed, null, 2);
      } catch {
        return jsonString;
      }
    },
    _formatDateTime(val) {
      return formatDateTime(val, true);
    },
    isUpdateStyleAudit(requestType) {
      return isCorrectionAuditRequest(requestType);
    }
  },
  beforeMount() {
    let vm = this;
    vm.frameworkComponents = {
      tableActions: TableActions
    };
    vm.columnDefs = [
      {
        headerName: "",
        field: "id",
        cellRenderer: "tableActions",
        cellRendererParams: {
          isAuditLog: true,
          clicked: function(param) {
            vm.existingOrder = true;
            switch (param.type) {
              case "auditLog":
                vm.selectedLog = param;
                vm.viewAuditLogDialog = true;
                break;
            }
          }
        },
        width: 50
      },
      {
        headerName: "NBN Order ID",
        field: "nbnOrderID"
      },
      {
        headerName: "AVC ID",
        field: "avcId"
      },
      {
        headerName: "User Email",
        field: "userEmail"
      },
      {
        headerName: "Request Type",
        field: "requestType"
      },
      {
        headerName: "Request Payload",
        field: "requestPayload"
      },
      {
        headerName: "Response",
        field: "response"
      },
      {
        headerName: "Date Time",
        field: "dateTime",
        cellRenderer: function(data) {
          return formatDateTime(data.value, true);
        }
      }
    ];
    vm.getAuditLogs();
  },
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
  }
};
</script>

<style scoped></style>
